import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const BlankRouterLink = styled(Link)`
    all: unset;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    text-decoration: none;
    width: max-content;
    color: inherit;
`;
